define('views/parts/chart/chart-line',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment', 'chartjs',
    // src
    'services/app-state',
    'services/viewport',
    'services/i18n',
    // templates
    'text!templates/parts/chart/chart-line.html',
], function(
    // Libs
    _, Backbone, Mustache, U, moment, Chart,
    // src
    AppState,
    Viewport,
    i18n,
    // templates
    TChartLine
) {

    var _extend = _.extend;

    var VChartLine = Backbone.View.extend({
        template: TChartLine,

        regions: {
            wrapper: '.chart-canvas',
            canvas: 'canvas'
        },

        initialize: function(opt) {
            var options = this.options = _extend({
                resize: true,
            }, opt);

            this.chartOptions = options.chart || {};

            this.setChartDefaults();
            this.extendChartOptions();

            this.color = AppState.getBrandColor();

            this.listenTo(AppState, 'change:color', this.onBrandColorChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));
            this.generateZones();

            this.onResize(Viewport.width());

            if (this.color) {
                this.color = AppState.getBrandColor().hex();
            }

            var context = this.zone.$canvas.get(0).getContext("2d");

            this.chart = new Chart(context, this.getConfig());

            return this;
        },

        updateChart: function(options) {

            var chart = this.chart,
                data = chart.data,
                chartOpt = chart.options,
                scales = chartOpt.scales || {},
                xAxes = scales.xAxes ? scales.xAxes[0] : {},
                yAxes = scales.yAxes ? scales.yAxes[0] : {};

            _extend(xAxes.scaleLabel, { labelString: options.xAxisUnit });
            _extend(yAxes.scaleLabel, { labelString: options.datasetUnit });

            _extend(xAxes.time, _.pick(options, ['max', 'min', 'unit', 'unitStepSize']));

            _extend(data.datasets[0], {
                data: options.data,
                label: i18n.t(options.datasetUnit),
            });

            data.labels = options.labels;
            chart.options.title.text = i18n.t(options.title);

            yAxes.ticks.max = options.yAxisMaxValue;
            yAxes.ticks.min = options.yAxisMinValue;
            
            yAxes.ticks.beginAtZero = options.yAxesBeginAtZero;

            chart.update();
        },

        extendChartOptions: function() {
            var chartOptions = this.chartOptions;
            chartOptions = _extend({}, chartOptions.options);
            chartOptions.scales = _extend({}, chartOptions.scales);
            chartOptions.scales.xAxes = _extend({}, chartOptions.scales.xAxes);
            chartOptions.scales.yAxes = _extend({}, chartOptions.scales.yAxes);
            this.chartOptions = chartOptions;
        },

        getConfig: function() {
            var chartOptions = this.chartOptions;
            return {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [{
                        pointBorderColor: this.color,
                        pointBackgroundColor: this.color,
                        pointBorderWidth: 2,
                        pointHoverRadius: 5,
                        pointRadius: 3,
                        borderColor: this.color,
                        lineTension: 0.2,
                        data: [],
                    }]
                },
                animation: {
                    easing: "linear",
                    numSteps: 50,
                },
                options: {

                    cutoutPercentage: 95,
                    defaultColor: this.color,
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                var value = data.datasets[0].data[tooltipItem.index];
                                return Math.round(value * 10) / 10;
                            },
                        },
                        bodyFontSize: 15,
                    },

                    title: _extend({
                        display: true,
                        padding: 25,
                        text: this.options.title || "",
                        fontSize: 16,
                        fontStyle: 'normal'
                    }, chartOptions.title),
                    elements: {
                        arc: {
                            borderWidth: 0,
                        }
                    },
                    scales: {
                        fit: function() {
                            this.maxHeight = 100;
                        },
                        xAxes: [_extend({
                            type: 'time',
                            ticks: {
                                maxTicksLimit: 5,
                            },
                            time: {
                                displayFormats: {
                                    'day': 'DD. MMM',
                                },
                                tooltipFormat: 'LL', //'dddd MMMM D, YYYY',
                                minUnit: "day",
                                unitStepSize: 1,
                                unit: 'day',
                                isoWeekday: true,
                            },
                            scaleLabel: {
                                display: true,
                                fontSize: 15
                            }
                        }, chartOptions.scales.xAxes)],
                        yAxes: [_extend({
                            scaleLabel: {
                                display: true,
                                fontSize: 15,
                            },
                            ticks: {
                              min: 0,
                              max: 0
                            }
                        }, chartOptions.scales.yAxes)]
                    }
                }
            };
        },

        setChartDefaults: function() {
            Chart.defaults.global.defaultFontFamily = "Lato , sans-serif";
            Chart.defaults.global.legend.display = false;
        },

        ////////////
        // events //
        ////////////
        onBrandColorChange: function(state, color, options) {
            this.color = color.hex();
            this.render();
        },

        onResize: function(width) {
            if (!this.options.resize) return;

            var $wrapper = this.zone.$wrapper;
            if (width < 544) $wrapper.height(400);
            else if (width < 768) $wrapper.height(500);
            else if (width < 992) $wrapper.height(600);
            else $wrapper.height(650);
        },

    });

    return VChartLine;

});

